import { PAGES } from './pages';

const HEADER = {
	MENU: [PAGES.builder, PAGES.settings, PAGES['get-responses'], PAGES.results],
};
export default HEADER;
